import { ObservationCode } from '@quromedical/fhir-common';
import {
  pathologyReportWithResultsColumns,
  getDataPathologyTestResultFromResponse,
} from 'core/diagnostic-report';
import { PatientHeaderSection } from 'core/patient';
import { PaginatedTable } from 'core/table';
import { Section } from 'design-system';
import { FetcherOptions } from 'hooks/usePaginatedData';
import { useResponsive } from 'hooks/useResponsive';
import { DiagnosticReportApi } from 'integration';
import { PathologyStackScreenProps } from 'navigation';
import React from 'react';
import { ScrollView } from 'react-native';

const api = new DiagnosticReportApi();

export const DiagnosticResults: React.FC<PathologyStackScreenProps<'View'>> = ({ route }) => {
  const showHeader = useResponsive({ md: true }, false);
  const isStriped = useResponsive({ md: true }, false);

  const { id, service } = route.params;

  const fetcher = (options: FetcherOptions) =>
    api.getDiagnosticResults({
      subject: id,
      pageToken: options.nextToken,
      basedOn: service,
      code: ObservationCode.pathologyTestResult,
      status: 'final',
    });

  const cacheKey = JSON.stringify({
    subject: id,
  });

  const columns = pathologyReportWithResultsColumns();

  return (
    <ScrollView>
      <PatientHeaderSection id={id} />
      <Section>
        <PaginatedTable
          cacheKey={`DiagnosticResults${cacheKey}`}
          fetcher={fetcher}
          columns={columns}
          showHeader={showHeader}
          isStriped={isStriped}
          getDataFromResponse={getDataPathologyTestResultFromResponse}
        />
      </Section>
    </ScrollView>
  );
};
